
<div class="form-group">
  <label class="lbl " for="form_id">{{dtaQuestions.name}}</label>
  <select class="" id="form_id" name="form_id" placeholder="Formulario...">
    <option *ngFor="let item of dtaQuestions.items" [value]="item">{{item}}</option>
  </select>
</div>
